import { render, staticRenderFns } from "./Xiezuophoto.vue?vue&type=template&id=9f007f98&"
import script from "./Xiezuophoto.vue?vue&type=script&lang=js&"
export * from "./Xiezuophoto.vue?vue&type=script&lang=js&"
import style0 from "./Xiezuophoto.vue?vue&type=style&index=0&id=9f007f98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports